/* Refresh the Air Max colour-count badges while the product page stays open.
   Shopify Liquid remains the source of truth; no hard-coded inventory values. */
(function () {
  'use strict';
  if (window.__dashAirMaxStockUpdater) return;
  window.__dashAirMaxStockUpdater = true;

  var refreshMs = 60000;
  var lastRefresh = 0;
  var refreshing = false;

  async function refresh() {
    if (refreshing || document.hidden) return;
    var picker = document.querySelector('[data-dash-airmax-stock-picker]');
    if (!picker) return;
    var sectionId = picker.getAttribute('data-dash-stock-section-id');
    var productUrl = picker.getAttribute('data-dash-stock-product-url');
    if (!sectionId || !productUrl) return;
    refreshing = true;
    lastRefresh = Date.now();

    try {
      var url = new URL(productUrl, window.location.origin);
      url.searchParams.set('section_id', sectionId);
      url.searchParams.set('dash_stock_refresh', String(lastRefresh));
      var response = await fetch(url.toString(), {
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (!response.ok) return;
      var markup = await response.text();
      var fragment = new DOMParser().parseFromString(markup, 'text/html');
      var freshPicker = fragment.querySelector('[data-dash-airmax-stock-picker]');
      if (!freshPicker) return;

      document.querySelectorAll('[data-dash-airmax-stock-picker]').forEach(function (currentPicker) {
        currentPicker.querySelectorAll('[data-dash-airmax-stock-id]').forEach(function (badge) {
          var variantId = badge.getAttribute('data-dash-airmax-stock-id');
          var freshBadge = Array.from(freshPicker.querySelectorAll('[data-dash-airmax-stock-id]'))
            .find(function (node) { return node.getAttribute('data-dash-airmax-stock-id') === variantId; });
          if (!freshBadge) return;
          badge.textContent = freshBadge.textContent.trim();
          badge.setAttribute('data-dash-airmax-stock-status', freshBadge.getAttribute('data-dash-airmax-stock-status') || 'normal');
          badge.className = freshBadge.className;
          var input = badge.closest('label') && document.getElementById(badge.closest('label').htmlFor);
          var freshInput = freshBadge.closest('label') && fragment.getElementById(freshBadge.closest('label').htmlFor);
          if (input && freshInput) {
            input.classList.toggle('disabled', freshInput.classList.contains('disabled'));
          }
        });
      });
    } catch (err) {
      /* On network failure, keep the last server-rendered numbers. */
    } finally {
      refreshing = false;
    }
  }

  window.setInterval(function () {
    if (Date.now() - lastRefresh >= refreshMs) refresh();
  }, refreshMs);

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && Date.now() - lastRefresh >= refreshMs) refresh();
  });
})();
